var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,style:({
    display: 'flex',
    flexDirection: _vm.direction,
    flexWrap: _vm.flexWrap,
    flexBasis: _vm.flexBasis,
    flexGrow: _vm.flexGrow,
    flexShrink: _vm.flexShrink,
    alignContent: _vm.alignContent,
    alignItems: _vm.alignItems,
    alignSelf: _vm.alignSelf,
    justifyContent: _vm.justifyContent,
    justifySelf: _vm.justifySelf,
    padding: _vm.paddingSx,
    width: _vm.width,
    ..._vm.sx
  }),attrs:{"id":_vm.id}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }